import Role from '@/model/role.js';
export default {
  userRoleName: (value) => Role.UserRoleName(value),
};
